<template>
<div>
    <slot name="hotel"></slot>
    <div class="im-label">
        {{ $t('reservations.modal.channel') }}
    </div>
    <div class="important mt-1 mb-2 d-flex align-center">
        <v-avatar class="mr-1" size="24" tile>
            <img :src="getLogo()">
        </v-avatar>
        <span v-if="item.channel == 'Q-Travel'">Christian Tour</span>
        <span v-else>{{ item.channel }}</span>
    </div>
    <div class="im-label">
        Status
    </div>
    <div class="regular mt-1 mb-2 text-capitalize">
        {{ item.status }}
    </div>
    <div class="im-label">
        {{ $t('reservations.modal.id') }}
    </div>
    <div class="important mt-1 mb-2">
        {{ item.external_id }}
    </div>
    <div class="im-label">
        {{ $t('reservations.modal.created_at') }}
    </div>
    <div class="regular mt-1 mb-2">
        {{ getLocalDate(item.created_at) }}
    </div>
</div>
</template>

<script>
import defaults from "../../../utils/PropDefaults.js";
import IMPrice from '../../../small-components/IMPrice.vue';
import Booking from '../../../../assets/bookingcom.svg';
import CHR from '../../../../assets/christian_tour.png';
import HLR from '../../../../assets/helloromania.png';

export default {
    components: {
        'im-price': IMPrice,
    },

    props: {
        item: {
            type: Object,
            default: function () {
                return defaults.reservation_item
            }
        },
    },

    data: () => {
        return {
            hello_romania: HLR,
            q_travel: CHR,
            booking: Booking,
        }
    },

    methods: {

        getLocalDate(value) {
            return this.$moment.utc(value)
                .local()
                .format('DD-MM-YYYY HH:mm:ss')
        },

        getLogo() {
            switch (this.item.channel) {
            case 'Hello-Romania':
                return this.hello_romania;
            case 'Q-Travel':
                return this.q_travel;
            case 'Booking':
                return this.booking;
            default:
                return null;
            }
        }

    },
}
</script>
